import type { Component } from 'solid-js'
import type { ComparedValue, PostData } from '../../../features/engagement/domain/models/community'
import ValueProgressCell from './custom-cells/ValueProgressCell'
import { KPI, KPIType } from '../../../features/analytics/domain/models/kpi'
import { NumericalDataType } from '../../../shared/models/numerical-data-type'

export interface TopPostsTableRowProps {
  readonly post: PostData
  readonly rowNumber: number
}

const TopPostsTableRow: Component<TopPostsTableRowProps> = (props) => {
  const kpi = (id: KPIType, value: ComparedValue) =>
    new KPI(id, value.current, NumericalDataType.Units, value.diff, value.previous)

  return (
    <tr class="hover:bg-gray-50 text-gray-700">
      <td class="whitespace-nowrap text-center text-sm">{props.rowNumber}</td>
      <td class="min-w-[260px]">
        <div class="flex flex-col text-sm">
          <span class="font-medium">{props.post.title}</span>
          <span class="text-gray-500">
            {props.post.createdBy}, {props.post.createdAt}
          </span>
        </div>
      </td>
      <td class="w-[156px]">
        <ValueProgressCell kpi={kpi(KPIType.ForumViews, props.post.views)} />
      </td>
      <td class="w-[156px]">
        <ValueProgressCell kpi={kpi(KPIType.ForumComments, props.post.comments)} />
      </td>
      <td class="w-[156px]">
        <ValueProgressCell kpi={kpi(KPIType.ForumUpvotes, props.post.upvotes)} />
      </td>
    </tr>
  )
}

export default TopPostsTableRow
